<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('operatingCompany') }}</h3>

            <div class="textBox">
                <dl>
                    <dt>{{ $t('companyName')}}</dt>
                    <dd>
                        Edu Tek Company Limited<br>
                        <a href="https://www.edutek.company/" target="_blank">https://www.edutek.company/</a>
                    </dd>
                </dl>
                <dl>
                    <dt>{{ $t('location')}}</dt>
                    <dd>
                        Oliaji Trade Centre, 1st Floor, Victoria, Mahe, Seychelles
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'company',
    }
</script>

<style>
</style>
